import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { selectWebsiteTheme } from '../../store/slices/website';
import CLFontIcon from '../CLFontIcon';

import {
  Container, Input, TextArea, InputIcon, ClearButton,
} from './styled';

const CLInput = ({
  value, onChange, placeholder, icon, multiline,
}) => {
  const { colors } = useSelector(selectWebsiteTheme);

  if (multiline) {
    return (
      <Container>
        {icon && (
          <InputIcon>
            <CLFontIcon icon={icon} />
          </InputIcon>
        )}
        <TextArea
          value={value}
          onChange={(event) => onChange(event.target.value)}
          hasIcon={!!icon}
          placeholder={placeholder}
          bColor={colors[3].color}
          bgColor={colors[0].color}
        />
        {value && (
          <ClearButton
            color={colors[4].color}
            onClick={() => onChange('')}
          >
            <CLFontIcon icon="close" />
          </ClearButton>
        )}
      </Container>
    );
  }

  return (
    <Container>
      {icon && (
        <InputIcon>
          <CLFontIcon icon={icon} />
        </InputIcon>
      )}
      <Input
        value={value}
        onChange={(event) => onChange(event.target.value)}
        hasIcon={!!icon}
        placeholder={placeholder}
        oColor={colors[6].color}
        bColor={colors[3].color}
        bgColor={colors[0].color}
      />
      {value && (
        <ClearButton
          color={colors[4].color}
          onClick={() => onChange('')}
        >
          <CLFontIcon icon="close" />
        </ClearButton>
      )}
    </Container>
  );
};

CLInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  multiline: PropTypes.bool,
};

CLInput.defaultProps = {
  value: '',
  placeholder: '',
  icon: null,
  multiline: false,
};

export default CLInput;
